import axios from 'axios'

export default {
    chat: (message, history = [], context = {}, config = {}) => axios.post('ai/chat', {
        message,
        history,
        rfc: context.rfc || '',
        period: context.period || '',
    }, config),
}
